
<a (click)="send()" class = "hoverblue" *ngIf="this.apiUrl; else noLink">{{this.phoneNumber.area + this.phoneNumber.number}} <fa-icon [icon]="iconWapp" size="1x" ></fa-icon> </a>

<ng-template #noLink>
    <span style="font-size: 0.9rem; font-weight: 525;">{{this.phoneNumber.area + this.phoneNumber.number}} </span>
</ng-template>
